import Guitar1 from "../../Assets/3DM/Gitar1.png";
import Guitar2 from "../../Assets/3DM/Gitar2.png";
import Guitar3 from "../../Assets/3DM/Gitar3.png";
import Guitar4 from "../../Assets/3DM/Gitar4.png";
import Room1 from "../../Assets/3DM/Room1.jpg";
import Room2 from "../../Assets/3DM/Room2.jpg";
import Room3 from "../../Assets/3DM/Room3.jpg";
import Room4 from "../../Assets/3DM/Room4.jpg";
import Room5 from "../../Assets/3DM/Room5.jpg";
import Robot1 from "../../Assets/3DM/Robot1.png";
import Robot2 from "../../Assets/3DM/Robot2.png";
import Robot3 from "../../Assets/3DM/Robot3.png";
import Robot4 from "../../Assets/3DM/Robot4.png";
import Robot5 from "../../Assets/3DM/Robot5.png";
import Robot6 from "../../Assets/3DM/Robot6.png";

import Our1 from "../../Assets/Web/Our1.png";
import Our2 from "../../Assets/Web/Our2.png";
import Our3 from "../../Assets/Web/Our3.png";
import Out1 from "../../Assets/Web/Out1.png";
import Out2 from "../../Assets/Web/Out2.png";
import Kom1 from "../../Assets/Web/Kom1.png";
import Kom2 from "../../Assets/Web/Kom2.png";
import Kom3 from "../../Assets/Web/Kom3.png";

import Man1 from "../../Assets/Grafisk/Man1.png";
import Man2 from "../../Assets/Grafisk/Man2.png";
import Man3 from "../../Assets/Grafisk/Man3.png";
import Man4 from "../../Assets/Grafisk/Man4.png";
import Man5 from "../../Assets/Grafisk/Man5.png";
import Bro1 from "../../Assets/Grafisk/Bro1.png";
import Bro2 from "../../Assets/Grafisk/Bro2.png";
import Bro3 from "../../Assets/Grafisk/Bro3.png";
import Bro4 from "../../Assets/Grafisk/Bro4.png";


export const CarouselDataGuitar = [
    {
        image: Guitar2,
        slug: 0,
    },
    {
        image: Guitar1,
        slug: 1,
    },
    {
        image: Guitar3,
        slug: 2,
    },
    {
        image: Guitar4,
        slug: 3,
    },
];

export const CarouselDataRoom = [
    {
        image: Room4,
        slug: 0,
    },
    {
        image: Room2,
        slug: 1,
    },
    {
        image: Room3,
        slug: 2,
    },
    {
        image: Room1,
        slug: 3,
    },
    {
        image: Room5,
        slug: 4,
    },
];

export const CarouselDataRobot = [
    {
        image: Robot1,
        slug: 0,
    },
    {
        image: Robot2,
        slug: 1,
    },
    {
        image: Robot3,
        slug: 2,
    },
    {
        image: Robot4,
        slug: 3,
    },
    {
        image: Robot5,
        slug: 4,
    },
    {
        image: Robot6,
        slug: 5,
    },
];

export const CarouselDataOur = [
    {
        image: Our1,
        slug: 0,
    },
    {
        image: Our2,
        slug: 1,
    },
    {
        image: Our3,
        slug: 2,
    },
];

export const CarouselDataOut = [
    {
        image: Out1,
        slug: 0,
    },
    {
        image: Out2,
        slug: 1,
    },

];

export const CarouselDataKom = [
    {
        image: Kom1,
        slug: 0,
    },
    {
        image: Kom2,
        slug: 1,
    },
    {
        image: Kom3,
        slug: 2,
    },

];

export const CarouselDataMan = [
    {
        image: Man1,
        slug: 0,
    },
    {
        image: Man2,
        slug: 1,
    },
    {
        image: Man3,
        slug: 2,
    },
    {
        image: Man4,
        slug: 3,
    },
    {
        image: Man5,
        slug: 4,
    }

];

export const CarouselDataBro = [
    {
        image: Bro1,
        slug: 0,
    },
    {
        image: Bro2,
        slug: 1,
    },
    {
        image: Bro3,
        slug: 2,
    },
    {
        image: Bro4,
        slug: 3,
    }

];

